import { render, staticRenderFns } from "./ChipIcon.vue?vue&type=template&id=ef7d3fc2&scoped=true&"
import script from "./ChipIcon.vue?vue&type=script&lang=js&"
export * from "./ChipIcon.vue?vue&type=script&lang=js&"
import style0 from "./ChipIcon.vue?vue&type=style&index=0&id=ef7d3fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7d3fc2",
  null
  
)

export default component.exports